import { linkForRefs } from "../../pageContext/resolvers";

/**
 * Resolves a tool-result `_link` value (an array of page-context refs) to an
 * in-app route. Returns `null` for missing, malformed, or unknown links, and
 * logs a warning when refs are present but can't be mapped to a route.
 */
export function resolveLink(rawLink: unknown): string | null {
  if (!Array.isArray(rawLink) || rawLink.length === 0) {
    return null;
  }

  const link = linkForRefs(rawLink);
  if (link === null) {
    console.warn("[AiChat] Unknown _link type:", rawLink);
  }

  return link;
}
